/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../shared/Typography';
import Card from '../../shared/Card';
import CodeBlock from './CodeBlock';

const Cards = () => {
  const { t } = useTranslation('cards');
  return (
    <React.Fragment>
      <Text h2 className='pattern-library__section-title'>{t('cards')}</Text>
      <CodeBlock>{t('info')}</CodeBlock>

      <Card>{t('regular_card')}</Card>
      <Card noShadow>noShadow</Card>
      <Card noRadius>noRadius</Card>
      <Card noPadding>noPadding</Card>
      <Card noPadding noShadow noRadius>noPadding, noRadius, noShadow</Card>
    </React.Fragment>
  );
};

export default Cards;



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/cards.js